import instance from '../api/axiosConfig';
import { AxiosResponse } from 'axios';

export const PendingResultKey = 'pendingResult';
type Config = {
  numberOfRetries?: number;
  postBody?: object;
};

export const requestWithRetry: <R extends object>(
  url: string,
  submit?: boolean,
  config?: Config
) => Promise<AxiosResponse<R>> = async (url, submit, config) => {
  const BaseDelayMs = 900;
  const MaxDelayMs = 30000;

  const retry: <R extends object>(
    attempt?: number
  ) => Promise<AxiosResponse<R>> = async (attempt = 0) => {
    try {
      if (submit) {
        if (config?.postBody) {
          return await instance.post(url, config.postBody);
        } else {
          return await instance.post(url);
        }
      } else {
        return await instance.get(url);
      }
    } catch (error) {
      if (config?.numberOfRetries && attempt >= config?.numberOfRetries) {
        throw error;
      }

      // Use an exponentially increasing delay to prevent flooding the server with requests or maximum delay.
      const delay = BaseDelayMs * Math.pow(2, attempt);

      if (delay > MaxDelayMs) {
        throw error;
      }

      return new Promise((resolve) =>
        setTimeout(() => resolve(retry(attempt + 1)), delay)
      );
    }
  };

  return retry();
};
